import { apiClient } from './client';

export interface PushSubscription {
  id: string;
  endpoint: string;
  userAgent: string | null;
  createdAt: string;
}

export interface NotificationItem {
  id: string;
  kind: string;
  title: string | null;
  body: string | null;
  mediaUrl: string | null;
  ctaUrl: string | null;
  scheduledAt: string | null;
  sentAt: string | null;
  stats: Record<string, unknown> | null;
  createdAt: string;
}

export interface PopupTemplate {
  id: string;
  name: string;
  htmlTemplate: string | null;
  varsSchema: Record<string, unknown> | null;
  createdAt: string;
}

export interface CreateNotificationDto {
  kind: 'push' | 'popup' | 'email' | 'wa';
  title: string;
  body: string;
  mediaUrl?: string;
  ctaUrl?: string;
  audience?: {
    all?: boolean;
    clientIds?: string[];
    tags?: string[];
    vipOnly?: boolean;
  };
  scheduledAt?: string;
}

export interface CreatePopupTemplateDto {
  name: string;
  htmlTemplate?: string;
  varsSchema?: Record<string, { type: 'string' | 'number' | 'boolean'; label: string }>;
}

export interface SendPopupDto {
  templateId: string;
  vars?: Record<string, string | number | boolean>;
  audience?: {
    all?: boolean;
    clientIds?: string[];
    tags?: string[];
    vipOnly?: boolean;
  };
}

export const notificationsApi = {
  listSubscriptions: async (): Promise<PushSubscription[]> => {
    const { data } = await apiClient.get('/admin/notifications/subscriptions');
    return data;
  },
  removeSubscription: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/notifications/subscriptions/${id}`);
  },
  listHistory: async (): Promise<NotificationItem[]> => {
    const { data } = await apiClient.get('/admin/notifications/history');
    return data;
  },
  create: async (dto: CreateNotificationDto): Promise<NotificationItem> => {
    const { data } = await apiClient.post('/admin/notifications', dto);
    return data;
  },
  sendNow: async (id: string): Promise<NotificationItem> => {
    const { data } = await apiClient.post(`/admin/notifications/${id}/send`);
    return data;
  },
  listTemplates: async (): Promise<PopupTemplate[]> => {
    const { data } = await apiClient.get('/admin/notifications/popups/templates');
    return data;
  },
  createTemplate: async (dto: CreatePopupTemplateDto): Promise<PopupTemplate> => {
    const { data } = await apiClient.post('/admin/notifications/popups/templates', dto);
    return data;
  },
  removeTemplate: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/notifications/popups/templates/${id}`);
  },
  sendPopup: async (dto: SendPopupDto): Promise<{ sent: number }> => {
    const { data } = await apiClient.post('/admin/notifications/popups/send', dto);
    return data;
  },
};
